module.exports = __webpack_public_path__ + "img/图片3.f421a023.png";